import React, { useState, useContext, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { updateWebInfo } from "../../utils/constants/userConstants";
import { UserContext } from "../MainLayout";
import ModalComponent from "../../utils/components/common/modalComponent/ModalComponent";
import LoadingSpinner from "../../utils/components/common/loadingSpinner/LoadingSpinner";

const Theme = () => {
  const [isLoading, setLoading] = useState(false);
  const [updateFailErr, setUpdateFailErr] = useState();
  const { userCognitoData, setNewTheme } = useContext(UserContext);

  const { t } = useTranslation("header");
  // Initializing theme state from localStorage or system preference
  const [theme, setTheme] = useState(
    localStorage.getItem("selectedTheme") || "light"
  );

  // Function to apply theme changes and save to localStorage
  const handleThemeChange = useCallback(
    async (e) => {
      try {
        setLoading(true);
        let newTheme = e.target.value;
        let value = newTheme;
        if (value === "system") {
          const isDarkMode =
            window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches;
          value = isDarkMode ? "dark" : "light";
        }
        localStorage.setItem("selectedTheme", newTheme);
        await updateWebInfo(userCognitoData?.username);
        setNewTheme(value);
        setTheme(newTheme);
      } catch (err) {
        setUpdateFailErr("genericErrMsg");
      }
      setLoading(false);
    },
    [setNewTheme, setTheme, userCognitoData]
  );

  const actualMode = useMemo(() => {
    let val = theme;
    if (val === "system") {
      const isDarkMode =
        window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches;
      val = isDarkMode ? "dark" : "light";
    }
    return val;
  }, [theme]);

  const onErrPopupclose = useCallback(() => {
    setUpdateFailErr("");
  }, []);

  return (
    <div className="theme-container component">
      <div className="header-section">
        <div>
          <span className="heading-h1 theme-heading">
            {t("theme.themeHeading")}&nbsp;
          </span>
          <span className="heading-text text-h1 theme-heading-sub-text">
            {t("theme.themeHeadingText")}
          </span>
        </div>
        <div className="main-radio-button-container">
          <div
            className={`single-btn-container ${
              theme === "light" ? "checked" : ""
            }`}
          >
            <input
              type="radio"
              name="options"
              className="radio-btn radio-btn-light"
              value="light"
              checked={theme === "light"}
              onChange={handleThemeChange}
            />
            <span className="btn-text heading-h1 light-btn-text">
              {t("theme.btn-text-light")}
            </span>
          </div>
          <div
            className={`single-btn-container ${
              theme === "dark" ? "checked" : ""
            }`}
          >
            <input
              type="radio"
              name="options"
              className="radio-btn radio-btn-dark"
              value="dark"
              checked={theme === "dark"}
              onChange={handleThemeChange}
            />
            <span className="btn-text heading-h1 dark-btn-text">
              {t("theme.btn-text-dark")}
            </span>
          </div>
          <div
            className={`single-btn-container ${
              theme === "system" ? "checked" : ""
            }`}
          >
            <input
              type="radio"
              name="options"
              className="radio-btn radio-btn-default"
              value="system"
              checked={theme === "system"}
              onChange={handleThemeChange}
            />
            <span>
              <span className="btn-text-2 heading-h1 default-btn-text">
                {t("theme.btn-text-system-default")}&nbsp;
              </span>
              <span className="default-btn-sub-text text-h4">
                {t("theme.btn-text-system-default-sub-text")}
              </span>
            </span>
          </div>
        </div>
      </div>
      <div className="preview-image-container">
        <div className="preview-image-text heading-h1">
          {t("theme.preview-image-text")}
        </div>
        <div>
          {actualMode === "light" ? (
            <img
              src={require("../../../src/assets/images/theme_image.png")}
              className="theme_image"
              alt="theme_image"
            />
          ) : (
            <img
              src={require("../../../src/assets/images/dark_theme_image.png")}
              className="dark_theme_image"
              alt="dark_theme_image"
            />
          )}
        </div>
      </div>
      {isLoading && <LoadingSpinner />}
      {/* Err Popup */}
      <ModalComponent
        idName="theme-error-modal"
        isOpen={updateFailErr}
        onCloseModal={onErrPopupclose}
        descriptionText={t(updateFailErr)}
      />
    </div>
  );
};

export default Theme;
